// extracted by mini-css-extract-plugin
export var adjacentSlide = "_q2-9";
export var arrowButtonContainer = "_q2-5";
export var arrowButtonIcon = "_q2-6";
export var carouselArrowButton = "_q2-2";
export var carouselElementContainer = "_q2-1";
export var currentSlide = "_q2-8";
export var left = "_q2-3";
export var otherSlide = "_q2-a";
export var productCarouselContainer = "_q2-0";
export var right = "_q2-4";
export var sliderOverflow = "_q2-7";